/**
 * Espace réservé en haut des pages SANS hero pour ne pas que le pill
 * flottant chevauche le contenu. Posé sur `<main>` dans `app/layout.tsx`.
 * Pages avec hero compensent avec `mt: -<NAVBAR_OFFSET>` pour passer
 * SOUS le pill et conserver l'effet d'overlay.
 *
 * ⚠️ Vit dans un module SANS `'use client'`. Cette constante est importée par
 * des Server Components (`layout.tsx`, `HomepageHero`) : exportée depuis un
 * module client (ex. `Navbar.tsx`), elle est résolue côté serveur en
 * client-reference (une fonction), pas en valeur — `${NAVBAR_OFFSET}` produit
 * alors `function(){}` et la règle CSS résultante est invalide (donc ignorée).
 */
export const NAVBAR_OFFSET = 96;
